// Browser tab title: "<app> <env> | <page>". Production shows no environment,
// so a tab without a label is always the live application.
//
// The application name carries the white label: the same deployment answers to
// commercialreview.nl, and ui-v1 took its title from `app.name` for that
// reason. It falls back to Stramigo until the application has been fetched.
export const buildPageTitle = (pageTitle, environment, applicationName) => {
  const env = environment && environment !== 'prod' ? ` ${environment}` : '';
  const base = `${applicationName || 'Stramigo'}${env}`;
  return pageTitle ? `${base} | ${pageTitle}` : base;
};
